import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const DBNIEBasicInfoComponent = ({ selectDbnie, handleInnerbasicFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        handleInnerbasicFormChange(
                        event.target.value,
                        'Name',
                    )
                    }}
                    type="text"
                    value={selectDbnie?.Name}
                />
                <InputContainer
                    label="URL"
                    name="URL"
                    onValueChange={(event: any) => {
                        handleInnerbasicFormChange(
                        event.target.value,
                        'URL',
                    )
                    }}
                    type="text"
                    value={selectDbnie?.URL}
                />
                   <InputContainer
                    label="Secret"
                    name="Secret"
                    onValueChange={(event: any) => {
                        handleInnerbasicFormChange(
                        event.target.value,
                        'Secret',
                    )
                    }}
                    type="text"
                    value={selectDbnie?.Secret}
                />
                <InputContainer
                    label="Active"
                    name="IsActive"
                    onValueChange={(event: any) => {
                        handleInnerbasicFormChange(
                        event,
                        'IsActive',
                    )
                    }}
                    type="checkbox"
                    value={selectDbnie?.IsActive}
                />
            </div>
            }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
        />
        </>
  )
}
export default DBNIEBasicInfoComponent;
